import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { setServiceManagerEmail, uploadFileOwnershipTransferRequest } from '../OwnershipTransferSlice';
import { FormSendType } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import FileInput from '../../../Shared/FileInput/FileInput';
import Helper from '../../../../utilities/helper';
import { recaptcha } from '../../../../utilities/recaptcha/recaptcha';
import TextInput from '../../../Shared/TextInput/TextInput';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';

const UploadFile = (props) => {

  const [emailError, setEmailError] = useState('');
  const validExtensions = 'csv';//props.iContent.extensions.value.split(',');//to do
  const maxSizeFileKb = '20';//props.iContent.fileSize.value;//to do
  const initialFileData = {
    fileName: '',
    extension: '',
    fileInBase64: '',
  };
  const [fileData, setFileData] = useState(initialFileData);
  const [isDragging, setDragging] = useState(false);
  const [fileError, setFileError] = useState('');
  const domain = `@${window.location.hostname}`;
  const [user, setUser] = useState(props.userDetails.userName || 'user');
  const [isMailChanged, setIsMailChanged] = useState(false);
  const [buttonError, setButtonError] = useState(false);

  useEffect(() => {
    if (props.data.maxSizeFileError) {
      setButtonError('הקובץ שהועלה גדול מדי או פורמט לא מתאים')
    }
  }, [props.data.maxSizeFileError])

  function submitUploading() {
    props.showAppLoader()
    if (fileData.fileName != '' && !emailError) {
      props.setServiceManagerEmail(user + domain);
      recaptcha().then(async (capchaValue) => {
        if (capchaValue != '' && capchaValue != null) {
          const transferRequest = {
            TransferRequest: {
              orgId: props.portalsBlock.selectedHetPayId,
              hetPayNumber: props.portalsBlock.selectedHetPay,
              orgName: props.portalsBlock.selectedOrgName,
              contactPersonFormMethod: props.data.contactPersonSendFormType.type,
              contactPersonFormMethodValue:
                props.data.contactPersonSendFormType.type == FormSendType.sms
                  ? props.data.contactPersonSendFormType.sms
                  : props.data.contactPersonSendFormType.email,
              serviceManagerEmail: user + domain,
              actionType: props.data.selectedActionType,
              equipmentObligations: props.data.responsibleForNextPayments,
            },
            File: {
              fileType: fileData.extension.toUpperCase(),
              FileContentBase64: fileData.fileInBase64,
              capchaValue,
              fileName: fileData.filename
            }
          };
          props.uploadFileOwnershipTransferRequest(transferRequest);
        }
      });

    }
    else {
      props.hideAppLoader();
      if (!fileData.fileName || fileData.fileName?.trim() == '') {
        setButtonError('כדי להמשיך יש לעלות קובץ פרטי הלקוחות')
      }
    }
  }


  async function uploadFile(file) {
    let fileConverted = await Helper.toBase64(file);
    let extension = file.type.split('/')[1];
    let fileSizeInKb = file.size / 1000;
    if (!validExtensions.includes(extension)) setFileError('הפורמט של הקובץ אינו תקין');
    if (fileSizeInKb > maxSizeFileKb) setFileError('אנא טען קובץ בגודל מתאים');

    setFileData({
      ...fileData,
      fileName: file.name.split('.')[0],
      extension,
      fileInBase64: fileConverted.replace(`data:${file.type};base64,`, ''),
    });
  }
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    setFileError('');
    uploadFile(e.dataTransfer.files[0]);
  };
  return (
    <div className='ownership-transfer-upload-file stepContainer ownership-transfer-step'>
      <div className='l-title '> העברת בעלות בגורף</div>
      <div className='m-title'>לאן לשלוח לך את סיכום העברת הבעלות?</div>
      <div className={`upload-email ${isMailChanged ? 'custom' : ''} `}>
        <TextInput
          value={user}
          error={emailError}
          id='mail'
          placeholder={'מייל'}
          onChange={(e) => {
            setUser(e.target.value)
            setEmailError(validateInput(e.target.value + domain, TextInputEnum.Mail));
            setIsMailChanged(true);
          }}
          required='required'
        />
        <div className='email-domain'>{domain}</div>
      </div>
      <div className='m-title center upload-file-msg'>
        עלייך לטעון את פרטי הלקוחות
        מסמכים במשקל של עד 20MB בפורמטים:
        csv
      </div>
      <div className='org-data'>
        <div className='org-name semi'>{props.portalsBlock.selectedOrgName}</div>
        <div className='org-het-pay-data '>
          <div className='het-pay-num'>{props.portalsBlock.selectedHetPay}</div>
        </div>
      </div>
      <div
        className='d-flex flex-column'
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => handleDrop(e)}>
        <FileInput
          id='fileInput'
          label='העלה או גרור קובץ לכאן'
          onChange={(e) => {
            uploadFile(e.target.files[0]);
            setFileError('');
          }}
          isDraggingOver={isDragging}
          filename={fileData.fileName}
          error={fileError}
          removeFile={() => {
            setFileData(initialFileData);
            setFileError('');
            setButtonError('');
          }}
        />
      </div>

      <div className='continue-button'>
        {buttonError && <div className='error center'>{buttonError}</div>}
        <BtnSubmit onclick={submitUploading} text={'המשך להזנת פרטי מנוי'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setServiceManagerEmail,
  uploadFileOwnershipTransferRequest,
  hideAppLoader,
  showAppLoader

};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
